var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M27 28h-21a1 1 0 0 0-1 1v33a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-33a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M27 1h-21a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-17a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M58 44h-21a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-17a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M58 1h-21a1 1 0 0 0-1 1v33a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-33a1 1 0 0 0-1-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.17088b9722da24dc85e24cd4f9fbcb21.svg";
export { ForwardRef as ReactComponent };